import jsPDF from 'jspdf'
import QRCode from 'qrcode'
import 'jspdf/dist/polyfills.es.js'
import { svg2pdf } from 'svg2pdf.js'

export async function generateQRPDF({
  siteName,
  cpName,
  connectorUid,
  stationId,
}) {
  const qrUrl = `https://nfc.infinityevcharge.com/charge?stationId=${stationId}&connectorId=${connectorUid}`

  const sanitize = (value) => String(value).replace(/[^a-zA-Z0-9]/g, '')
  const fileName = `${sanitize(siteName)}_${cpName}_${connectorUid}.pdf`
  const qrSvgString = await QRCode.toString(qrUrl, {
    type: 'svg',
    errorCorrectionLevel: 'H',
    margin: 2,
    color: {
      dark: '#000000',
      light: '#FFFFFF',
    },
  })

  const doc = new jsPDF({
    unit: 'mm',
    format: [100, 100],
  })

  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const margin = 2

  const svgElement = new DOMParser().parseFromString(
    qrSvgString,
    'image/svg+xml',
  ).documentElement

  await svg2pdf(svgElement, doc, {
    x: margin,
    y: margin,
    width: pageWidth - 2 * margin,
    height: pageHeight - 2 * margin,
  })

  doc.save(fileName)
}
